import AbstractSiteApi from '../AbstractSiteApi';

import { GetDrawsForCalendarResponse, GetResultsForLotteryResponse } from './Responses';

class LatestResultsApi extends AbstractSiteApi {
    protected endpoint: string = 'latest-results';

    async getSportBetsResults(lotteryDrawId: number): Promise<any> {
        const response = await this.get(`/sport-bets/${lotteryDrawId}`);
        return response.data;
    }

    /**
     * @param date The date of month in the format `Y-m`
     */
    async getDrawsForCalendar(lotterySlug: string, date: string): Promise<GetDrawsForCalendarResponse> {
        return (await this.get(`/calendar-draws/${lotterySlug}`, { params: { date } })).data;
    }

    async getResultsForLottery(lotterySlug: string, drawSelected: number): Promise<GetResultsForLotteryResponse> {
        const drawNoSegment = drawSelected ? `/${drawSelected}` : '';
        return (await this.get(`/lottery-results/${lotterySlug}${drawNoSegment}`)).data;
    }
}

export default new LatestResultsApi();
